module.exports = __webpack_public_path__ + "static/media/pencil-alt.6c004f9d.svg";